import { ApolloError, useQuery } from '@apollo/client'
import { RESIGNED_EMPLOYEE_PUBLIC_PROFILE } from './Queries'
import { ResignedEmployeePublicProfileQuery, ResignedEmployeePublicProfileQueryVariables } from '../../types'

//useResignedEmployeePublicProfile
export default (
  employeeId: string,
): {
  data: ResignedEmployeePublicProfileQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<ResignedEmployeePublicProfileQuery, ResignedEmployeePublicProfileQueryVariables>(
    RESIGNED_EMPLOYEE_PUBLIC_PROFILE,
    {
      variables: {
        id: employeeId,
      },
    },
  )

  return { data, error, loading }
}
